module.exports = __webpack_public_path__ + "static/sponsorship_mapM@2x-4c3b1c114d4f59ce66b06f78e835f2c5.png";